export default "__VITE_ASSET__Dfww12WL__"